import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Annulée',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Reçue',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Confirmée',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'En préparation',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'En route',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Prête',
  status: {
    actual: 'Actuel',
    pending: 'En attente',
  },
  warning_label: {
    pickup_time_changed: "{{company}} a modifié l'heure de {{initialTime}} à {{currentTime}}",
  },
  labels: {
    order_number: 'Commande n° : {{number}}',
    today: "Aujourd'hui",
  },
};
